(function () {
  var ROOT_SEL  = '.cust-featured-collection';
  var INNER_SEL = [
    '.css-slider',                          // your inner scroller element
    '.product-variant__container',          // wrapper holding radio items
    '[data-js-product-variant-container]',  // theme attr
    '.product-variant__item',
    '.product-variant__label',
    '.product-variant__input'
  ].join(',');

  var root = document.querySelector(ROOT_SEL);
  if (!root) return;

  function bindStopPropagation(el) {
    if (!el || el.dataset.slickGuardBound === '1') return;
    var stop = function (e) { e.stopPropagation(); };
    // Bind on the TARGET (bubble phase) so ancestors (Slick) never see it.
    ['pointerdown','pointermove','touchstart','touchmove','mousedown','mousemove','click']
      .forEach(function (type) { el.addEventListener(type, stop, false); });
    el.dataset.slickGuardBound = '1';
  }

  // Bind to all current inner elements
  root.querySelectorAll(INNER_SEL).forEach(bindStopPropagation);

  // Bind to future ones (quick-buy etc.)
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches(INNER_SEL)) bindStopPropagation(node);
        node.querySelectorAll && node.querySelectorAll(INNER_SEL).forEach(bindStopPropagation);
      });
    });
  });
  mo.observe(root, { childList: true, subtree: true });
})();
